import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ScreenTypeDirective } from './directives';

const DIRECTIVES = [
  ScreenTypeDirective,
];

@NgModule({
  declarations: [
    ...DIRECTIVES,
  ],
  imports: [
    TranslateModule,
  ],
  exports: [
    ...DIRECTIVES,
    TranslateModule,
  ],
})
export class SharedModule {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      'customer_avatar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/avatar.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_solar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/solar.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_refresh',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/refresh.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_time_refresh',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/time-refresh.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_default_device',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/default-device.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_azzurro_battery',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/azzurro-battery.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_evcharge',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/ev-charge.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_heat_pump',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/heat-pump.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_azzurro_hub',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/azzurro-hub.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_connext',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/connext.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_azzurro_hub',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/azzurro-hub.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_heatpump_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/heatpump-icon.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_other_loggers',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/other-loggers.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_connext_update',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/connext-update.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_stick_logger',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/stick-logger.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_combox',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/combox.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_meter',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/meter.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'export_notes',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/export-notes.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_inverter',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/inverter.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'customer_verified',
      this.domSanitizer.bypassSecurityTrustResourceUrl('sets/images/svg/verified.svg'),
    );
    ['it', 'en', 'pl', 'es', 'fr', 'de', 'gr', 'ua', 'pt'].forEach((lang) => {
      this.matIconRegistry.addSvgIcon(
        lang,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/flags/${lang}.svg`),
      );
    });
  }
}
